import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { LayoutDashboard, Activity, TrendingUp } from 'lucide-react';

interface DashboardTabsProps {
  overviewContent: React.ReactNode;
  activityContent: React.ReactNode;
  insightsContent: React.ReactNode;
  activeTab?: string;
  onTabChange?: (tab: string) => void;
}

export function DashboardTabs({
  overviewContent,
  activityContent,
  insightsContent,
  activeTab = 'overview',
  onTabChange,
}: DashboardTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <TabsList className="grid w-full grid-cols-3 mb-4">
        <TabsTrigger value="overview" className="flex items-center gap-2">
          <LayoutDashboard className="h-4 w-4" />
          <span className="hidden sm:inline">Overview</span>
          <span className="sm:hidden">Stats</span>
        </TabsTrigger>
        <TabsTrigger value="activity" className="flex items-center gap-2">
          <Activity className="h-4 w-4" />
          <span className="hidden sm:inline">Activity</span>
          <span className="sm:hidden">Recent</span>
        </TabsTrigger>
        <TabsTrigger value="insights" className="flex items-center gap-2">
          <TrendingUp className="h-4 w-4" />
          <span className="hidden sm:inline">Insights</span>
          <span className="sm:hidden">Trends</span>
        </TabsTrigger>
      </TabsList>

      <TabsContent value="overview" className="space-y-4 animate-in fade-in-50 duration-300">
        {overviewContent}
      </TabsContent>

      <TabsContent value="activity" className="space-y-4 animate-in fade-in-50 duration-300">
        {activityContent}
      </TabsContent>

      <TabsContent value="insights" className="space-y-4 animate-in fade-in-50 duration-300">
        {insightsContent}
      </TabsContent>
    </Tabs>
  );
}
